export default __webpack_public_path__ + "static/media/Logo_white_back.4080f111.png";